import { render, staticRenderFns } from "./EstatusArmaDialogComponent.vue?vue&type=template&id=fe7bddb8"
import script from "./EstatusArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EstatusArmaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports